import {Component, input} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {FieldContainerComponent} from '@shared/form/field-container/field-container.component';
import {StringFieldBaseComponent} from '@shared/form/string/string-field-base.component';
import {CharsLeftComponent} from '@shared/form/string/chars-left/chars-left.component';

@Component({
  selector: 'app-email-field',
  imports: [
    ReactiveFormsModule,
    FieldContainerComponent,
    CharsLeftComponent
  ],
  templateUrl: './email-field.component.html',
  styleUrl: './email-field.component.scss'
})
export class EmailFieldComponent extends StringFieldBaseComponent {

  public readonly charsLeftThreshold = input(5);

}
